
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

import getActionDeletarGrupo from 'src/actions/chats/getActionDeletarGrupo';

import { getStaff, getListaStaffsWithoutIsGroup, setSelectedChat, getChatInternoBuscarChat } from '../../../redux/slices/staff';
import { useDispatch, useSelector } from '../../../redux/store';
import ChatStaffItem from './ChatStaffItem';
import { setSessionStorageItem } from 'src/services/sessionStorage';
import v2_actionChatInternoBuscarChat from 'src/actions/v2/chats/chat-interno/v2_actionChatInternoBuscarChat';
import v2_actionChatInternoEditarGrupo from 'src/actions/v2/chats/chat-interno/v2_actionChatInternoEditarGrupo';
import { ScrollArea } from 'src/@/components/ui/scroll-area';
import Iconify from 'src/components/Iconify';

const Contacts = ({
  chats,
  user,
  onlineUsers,
  roomsWithNewMessages,
  isOpenSidebar,
  onSelectConversation,
  onDelete,
  selectedChat,
  contactList
}) => {
  return (
    <ScrollArea className="flex-1 min-w-0">
      <div className="flex flex-col overflow-hidden">
        {chats?.map((chat, index) => (
          <div
            key={chat._id}
            className="animate-in fade-in duration-200 fill-mode-backwards overflow-hidden min-w-0"
            style={{ animationDelay: `${Math.min(index * 30, 300)}ms` }}
          >
            <ChatStaffItem
              chat={chat}
              user={user}
              onlineUsers={onlineUsers}
              onDelete={() => onDelete(chat)}
              roomsWithNewMessages={roomsWithNewMessages}
              isOpenSidebar={isOpenSidebar}
              onSelectConversation={() => onSelectConversation(chat)}
              selectedChat={selectedChat}
              contactList={contactList}
            />
          </div>
        ))}

        {chats?.length === 0 && (
          <div className="flex flex-col items-center justify-center py-16 text-center px-4">
            <div className="w-12 h-12 rounded-2xl bg-gray-100 dark:bg-neutral-800 flex items-center justify-center mb-3 text-gray-300 dark:text-neutral-600">
              <Iconify icon="mdi:chat-outline" width={22} />
            </div>
            <p className="text-sm font-medium text-gray-400">Nenhuma conversa</p>
            <p className="text-xs text-gray-300 dark:text-neutral-600 mt-1">Inicie uma nova conversa</p>
          </div>
        )}
      </div>
    </ScrollArea>
  );
};

export default function ChatInternoListaChats({ chats, user, isOpenSidebar, contactList, onCallback, ...other }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { roomsWithNewMessages, onlineUsers, selectedChat } = useSelector((state) => state.staff);

  async function buscarChatInterno(id) {
    let querys = `?limit=10&skip=0&msgs=1`
    const response = await v2_actionChatInternoBuscarChat(id, querys)
    if (response.status === 200) {
      setSessionStorageItem('chatInternoMiniId', response.data.room);
    }
  }


  const handleChoose = async (chat) => {

    if (contactList) {
      buscarChatInterno(chat._id)
      onCallback();
      return;
    }
    const target = `/chats/interno/${chat._id}`;
    navigate(target);
    dispatch(getChatInternoBuscarChat(chat._id))
    dispatch(setSelectedChat(chat))
  }


  const handleDeletarGrupo = async (chat) => {


    try {
      await v2_actionChatInternoEditarGrupo(chat._id, { deleted: false })
      dispatch(getListaStaffsWithoutIsGroup())

    } catch (error) {
      console.log(error)
    }

    getActionDeletarGrupo({ chatId: chat._id }).then(() => {
      dispatch(getListaStaffsWithoutIsGroup())
    })
  }


  return (
    <Contacts
      chats={chats}
      user={user}
      onlineUsers={onlineUsers}
      roomsWithNewMessages={roomsWithNewMessages}
      isOpenSidebar={isOpenSidebar}
      onSelectConversation={handleChoose}
      onDelete={handleDeletarGrupo}
      selectedChat={selectedChat}
      contactList={contactList}
    />
  )
}
